import styled from "styled-components";
import { accessibleShade } from "../accessibleColor";
import { space, SpaceProps, typography, TypographyProps } from "styled-system";

export const LinkButton = styled.button<SpaceProps & TypographyProps>`
  background: none !important;
  border: none;
  padding: 0 !important;
  cursor: pointer;
  display: inline;
  text-align: left;
  color: ${(props) => accessibleShade(props.theme.colors.primary)};
  font-weight: inherit;

  &:hover {
    text-decoration: underline;
  }

  &:active:not(:disabled) {
    opacity: 0.7;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.grey0};
    outline-offset: 2px;
  }
  ${space}
  ${typography}
`;

export type LinkButtonProps = React.ComponentProps<typeof LinkButton>;
